"use strict";

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.factory("deferredUtils", function ($q, $injector) {
  return {
    resolvePromiseMap: function resolvePromiseMap(resolve) {
      var promises = {};
      _.each(resolve, function (value, key) {
        promises[key] = _.isString(value) ? $injector.get(value) : $injector.invoke(value);
      });
      return $q.all(promises);
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/core/utils/deferredUtils.js
// module id = 2749
// module chunks = 13